import React from "react";
import { useSelector } from "react-redux";
import {
  deletAssignedKra,
  getAllAssignedKra,
} from "../../../../../redux/features/appraisalSlice";
import GlobalDeleteDialog from "../../../../../components/mui/Dialogue/GlobalDeleteDialog";

const DeleteAssignedKra = ({ id, data }) => {
  const { loading } = useSelector((state) => state.appraisal);
  const { paginationData, openAnchor } = useSelector(
    (state) => state.globalDataGrid
  );

  return (
    <GlobalDeleteDialog
      title={"Delete Library"}
      deleteNote={"Are you sure? you want to delete this tag ?"}
      api={deletAssignedKra([id])}
      upDateCall={getAllAssignedKra(data)}
      loading={loading}
    />
  );
};

export default DeleteAssignedKra;
